import {useState, PropsWithChildren} from 'react'
import {FundProfileContext} from '../FundProfileContext'

export const FundProfileContextProvider = (props: PropsWithChildren) => {
    const [holiday, setHoliday] = useState<Array<string>>([])

    return (
        <FundProfileContext.Provider
            value={{
                holiday,
                setHoliday,
            }}>
            {props.children}
        </FundProfileContext.Provider>
    )
}
